import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "../screen/Login";
import Dashboard from "../screen/Home";
import Sidebar from "../layouts/Sidebar";
import Layout from "../layouts/Layout";
import Account from "../screen/Account";
import Product from "../screen/Product";
import EditProduct from "../screen/EditProduct";
import AddSerial from "../screen/AddSerial";
import AddProduct from "../screen/AddProduct";
import OffersList from "../screen/OffersList";
import AddOffer from "../screen/AddOffer";
import EditOffer from "../screen/EditOffer";
import FacetsList from "../screen/FacetsList";
import AddFacet from "../screen/AddFacet";
import EditFacet from "../screen/EditFacet";
import TagsList from "../screen/TagsList";
import CompleteOrdersList from "../screen/CompleteOrdersList";
import UserOrders from "../screen/UserOrders";
import OrderItems from "../screen/OrderItems";
import EditAccount from "../screen/EditAccount";
import Users from "../screen/Users";
import AddUser from "../screen/AddUser";
import EditUser from "../screen/EditUser";
import AlwaseetOrders from "../screen/AlwaseetOrders";
import AlwaseetInvoices from "../screen/AlwaseetInvoices"
import AlwaseetStatuses from "../screen/AlwaseetStatuses"
import AlwaseetOrderDetails from "../screen/AlwaseetOrderDetails"
import AlwaseetInvoiceDetails from "../screen/AlwaseetInvoiceDetails"
import UnCompleteOrdersList from "../screen/UnCompleteOrdersList";
import UnCompleteUserOrders from "../screen/UnCompleteUserOrders";
import SerialAgent from "../screen/SerialAgent";
import CompanySerials from "../screen/CompanySerials";
import OffersPoint from "../screen/OffersPoint";
import RedeemRequests from "../screen/RedeemRequests";
import TechnicalJoinRequests from "../screen/TechnicalJoinRequests";
import AgentJoinRequests from "../screen/AgentJoinRequests";
import TechniciansDetails from "../screen/TechniciansDetails";
import SerialNumber from "../screen/SerialNumber";
import SerialComparison from "../screen/SerialComparison";
import SerialModelNameMapper from "../screen/SerialModelNameMapper"
import MovementSerialFilter from "../screen/MovementSerialFilter"
import AssignUserSerials from "../screen/AssignUserSerials";
import { useAuth } from "../contexts/AuthContext";
import Brands from "../screen/Brands";
import Categories from "../screen/Categories";
import FilterOptions from "../screen/FilterOptions";
import Inventory from "../screen/Inventory";
import Warehouses from "../screen/Warehouses";
import InventoryTransfers from "../screen/InventoryTransfers";

import DashboardUsers from "../screen/DashboardUsers";
import AddDashboardUser from "../screen/AddDashboardUser";
import EditDashboardUser from "../screen/EditDashboardUser";
import DashboardProfile from "../screen/DashboardProfile";
import NotificationCampaigns from "../screen/NotificationCampaigns";
import AddNotificationCampaign from "../screen/AddNotificationCampaign";
import EditNotificationCampaign from "../screen/EditNotificationCampaign";
import NotificationCampaignDetails from "../screen/NotificationCampaignDetails";
import AccountUpgradeRequests from "../screen/AccountUpgradeRequests";
import AccountUpgradeRequestDetails from "../screen/AccountUpgradeRequestDetails";
import AdminOrders from "../screen/AdminOrders";
import AdminOrderDetails from "../screen/AdminOrderDetails";
import Advertisements from "../screen/Advertisements";
import AddAdvertisement from "../screen/AddAdvertisement";
import EditAdvertisement from "../screen/EditAdvertisement";
import AdvertisementDetails from "../screen/AdvertisementDetails";
import Suppliers from "../screen/Suppliers";
import SupplierOpeningBalances from "../screen/SupplierOpeningBalances";
import PurchaseOrders from "../screen/PurchaseOrders";
import GoodsReceipts from "../screen/GoodsReceipts";


const AppRoutes: React.FC = () => {
const {
  firebaseUser,
  session,
  loading,
  logout,
} = useAuth();
console.log(
  "Dashboard session:",
  session?.dashboard,
);

const isAuthenticated = Boolean(
  firebaseUser &&
  session?.dashboard &&
  session.dashboard.isActive,
);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          direction: "rtl",
        }}
      >
        جارٍ التحقق من جلسة تسجيل الدخول...
      </div>
    );
  }
  return (
    <Router>
      {isAuthenticated ? (
        <div className="flex">
     <Sidebar onLogout={logout} />
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/Account" element={<Account />} />
              <Route path="/Product" element={<Product />} />
<Route
  path="/inventory"
  element={<Inventory />}
/>

<Route
  path="/warehouses"
  element={<Warehouses />}
/>

<Route
  path="/inventory-transfers"
  element={<InventoryTransfers />}
/>
              <Route
                path="/dashboard/edit-product/:id"
                element={<EditProduct />}
              />
              <Route path="/dashboard/addSerial/:id" element={<AddSerial />} />
              <Route path="/add-product" element={<AddProduct />} />
              <Route path="/OffersList" element={<OffersList />} />
              <Route path="/AddOffer" element={<AddOffer />} />
              <Route path="/dashboard/edit-offer/:id" element={<EditOffer />} />
              <Route path="/Facet" element={<FacetsList />} />
              <Route path="/dashboard/add-facet" element={<AddFacet />} />
              <Route path="/dashboard/edit-facet/:id" element={<EditFacet />} />
              <Route path="/tags" element={<TagsList />} />
              <Route path="/Users" element={<Users />} />
              <Route path="/AddUser" element={<AddUser />} />
              <Route path="/dashboard/EditUser/:id" element={<EditUser />} />
             
              <Route path="/dashboard/SerialAgent" element={<SerialAgent/>}/>
              <Route path="/dashboard/company-serials" element={<CompanySerials />} />
              <Route path="/dashboard/OffersPoint" element={<OffersPoint />} />
              <Route path="/dashboard/edit-OffersPoint/:id" element={<EditOffer />} />
              <Route path="/dashboard/redeem-requests" element={<RedeemRequests />} />
              <Route path="/technical-join-requests" element={<TechnicalJoinRequests />} />
              <Route path="/agent-join-requests" element={<AgentJoinRequests />} />
              <Route path="/technicians-details" element={<TechniciansDetails />} />
                            <Route path="/dashboard/SerialNumber" element={<SerialNumber />} />
<Route path="/dashboard/serial-comparison" element={<SerialComparison />} />
<Route path="/dashboard/MovementSerialFilter" element={<MovementSerialFilter />} />
<Route path="/dashboard/SerialModelNameMapper" element={<SerialModelNameMapper />} />
<Route path="/brands" element={<Brands />} />
<Route path="/categories" element={<Categories />} />
<Route path="/filter-options" element={<FilterOptions />} />
              <Route
                path="/CompleteOrdersList"
                element={<CompleteOrdersList />}
              />
              <Route
                path="/dashboard/EditAccount/:id"
                element={<EditAccount />}
              />
              <Route
                path="/dashboard/user-orders/:userId"
                element={<UserOrders />}
              />
              <Route
  path="/dashboard/assign-user-serials"
  element={<AssignUserSerials />}
/>
              <Route
                path="/dashboard/user-orders/:userId/:orderId"
                element={<OrderItems />}
              />
            <Route path="/alwaseet-orders" element={<AlwaseetOrders />} />
<Route path="/alwaseet-invoices" element={<AlwaseetInvoices />} />
<Route path="/alwaseet-statuses" element={<AlwaseetStatuses />} />
<Route path="/alwaseet-order-details/:id" element={<AlwaseetOrderDetails />} />
<Route path="/alwaseet-invoice-details/:id" element={<AlwaseetInvoiceDetails />} />
<Route path="/uncomplete-orders" element={<UnCompleteOrdersList />} />
<Route
  path="/dashboard/uncomplete-user-orders/:userId"
  element={<UnCompleteUserOrders />}
/>
<Route
  path="/dashboard-users"
  element={<DashboardUsers />}
/>

<Route
  path="/dashboard-users/add"
  element={<AddDashboardUser />}
/>

<Route
  path="/dashboard-users/:uid/edit"
  element={<EditDashboardUser />}
/>

<Route
  path="/notification-campaigns"
  element={
    <NotificationCampaigns />
  }
/>

<Route
  path="/suppliers"
  element={<Suppliers />}
/>


<Route
  path="/supplier-opening-balances"
  element={
    <SupplierOpeningBalances />
  }
/>

<Route
  path="/purchase-orders"
  element={<PurchaseOrders />}
/>
<Route
  path="/goods-receipts"
  element={<GoodsReceipts />}
/>
<Route
  path="/notification-campaigns/add"
  element={
    <AddNotificationCampaign />
  }
/>

<Route
  path="/notification-campaigns/:campaignId"
  element={
    <NotificationCampaignDetails />
  }
/>

<Route
  path="/notification-campaigns/:campaignId/edit"
  element={
    <EditNotificationCampaign />
  }
/>
<Route
  path="/account-upgrade-requests"
  element={
    <AccountUpgradeRequests />
  }
/>

<Route
  path="/account-upgrade-requests/:requestId"
  element={
    <AccountUpgradeRequestDetails />
  }
/>

<Route
  path="/orders-admin"
  element={
    <AdminOrders />
  }
/>

<Route
  path="/orders-admin/:orderId"
  element={
    <AdminOrderDetails />
  }
/>

<Route
  path="/profile"
  element={
    <DashboardProfile />
  }
/>
<Route
  path="/advertisements"
  element={
    <Advertisements />
  }
/>

<Route
  path="/advertisements/add"
  element={
    <AddAdvertisement />
  }
/>

<Route
  path="/advertisements/:id"
  element={
    <AdvertisementDetails />
  }
/>

<Route
  path="/advertisements/:id/edit"
  element={
    <EditAdvertisement />
  }
/>

              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Layout>
        </div>
      ) : (
        <Routes>
        <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      )}
    </Router>
  );
};

export default AppRoutes;
